import React from "react";
import "./CMCServices.css";
import PageHeader from "../../components/headers/PageHeader";
import wave from "../../assets/Images/waves/wave_mou.png";

export default function CMCServices() {
    return (
        <div className="cmcservices-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="CMC Statistical Consulting"
                title="CMC Services"
            />

            <section className="cmcservices-section cmcservices-introSection">
                <h2>Statistical Consulting for CMC Development and Regulatory Readiness</h2>

                <p>
                    We provide CMC statistical consulting services to support analytical
                    development, manufacturing validation, process monitoring, product
                    comparability, biosimilar similarity evaluation, and regulatory
                    submission readiness for our valued clients.
                </p>

                <p>
                    Our consulting approach combines applied statistics, CMC development
                    understanding, quality expectations, and regulatory alignment to help
                    sponsors make scientifically justified and inspection-ready decisions.
                </p>
            </section>

            <section className="cmcservices-section cmcservices-serviceSection">
                <h2>Our CMC Statistical Consulting Services</h2>

                <p className="cmcservices-sectionIntro">
                    We support clients across the following CMC statistical consulting
                    areas:
                </p>

                <div className="cmcservices-serviceGrid">
                    <article className="cmcservices-serviceCard">
                        Analytical Method Validation Statistics
                    </article>

                    <article className="cmcservices-serviceCard">
                        Stability Analysis &amp; Shelf-Life Estimation
                    </article>

                    <article className="cmcservices-serviceCard">
                        Process Validation Statistics
                    </article>

                    <article className="cmcservices-serviceCard">
                        Continued Process Verification
                    </article>

                    <article className="cmcservices-serviceCard">
                        Design of Experiments
                    </article>

                    <article className="cmcservices-serviceCard">
                        Quality by Design Analytics
                    </article>

                    <article className="cmcservices-serviceCard">
                        Specification Setting &amp; Justification
                    </article>

                    <article className="cmcservices-serviceCard">
                        Dissolution Profile Comparisons
                    </article>

                    <article className="cmcservices-serviceCard">
                        Manufacturing Trend Analysis
                    </article>

                    <article className="cmcservices-serviceCard">
                        Comparability Assessments
                    </article>

                    <article className="cmcservices-serviceCard">
                        Biosimilar Analytical Similarity Evaluations
                    </article>

                    <article className="cmcservices-serviceCard">
                        Regulatory Submission Support
                    </article>
                </div>
            </section>

            <section className="cmcservices-section cmcservices-supportSection">
                <h2>How We Support CMC Programs</h2>

                <div className="cmcservices-cardGrid">
                    <article className="cmcservices-card">
                        <h3>Analytical and Method Validation Support</h3>

                        <p>
                            Statistical support for analytical method validation,
                            method performance evaluation, validation acceptance criteria,
                            robustness assessment, and regulatory documentation.
                        </p>
                    </article>

                    <article className="cmcservices-card">
                        <h3>Stability and Shelf-Life Analytics</h3>

                        <p>
                            Statistical modelling for stability data, shelf-life estimation,
                            trend evaluation, degradation assessment, and product quality
                            decision-making.
                        </p>
                    </article>

                    <article className="cmcservices-card">
                        <h3>Process Validation and CPV</h3>

                        <p>
                            Statistical consulting for process validation, continued process
                            verification, manufacturing consistency, control strategy
                            monitoring, and process capability evaluation.
                        </p>
                    </article>

                    <article className="cmcservices-card">
                        <h3>QbD, DoE, and Specification Strategy</h3>

                        <p>
                            Support for Design of Experiments, Quality by Design analytics,
                            design space development, specification setting, and scientific
                            justification of quality attributes.
                        </p>
                    </article>

                    <article className="cmcservices-card">
                        <h3>Comparability and Biosimilar Similarity</h3>

                        <p>
                            Quantitative support for comparability assessments, analytical
                            similarity evaluations, manufacturing changes, and biosimilar
                            evidence packages.
                        </p>
                    </article>

                    <article className="cmcservices-card">
                        <h3>Regulatory Submission Support</h3>

                        <p>
                            Statistical documentation, data interpretation, regulatory
                            response support, and submission-ready analytics for CMC
                            sections of regulatory applications.
                        </p>
                    </article>
                </div>
            </section>
        </div>
    );
}